// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseFareForm-baseFareFormText-ITy41 {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: var(--primary-foreground);
    margin-bottom: 12px;
    text-align: start;
}

.BaseFareForm-baseFareFormLabelTextContainer-sVu9E {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    grid-gap: 6px;
    margin-bottom: 6px;
}

.BaseFareForm-baseFareFormLabelText-MT2A9 {
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    color: var(--primary-foreground);
    text-align: start;
}`, "",{"version":3,"sources":["webpack://./src/components/ManageSubCategory/ManageSubCategoryItem/BaseFareForm/BaseFareForm.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;AACrB","sourcesContent":[".baseFareFormText {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--primary-foreground);\n    margin-bottom: 12px;\n    text-align: start;\n}\n\n.baseFareFormLabelTextContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    margin-bottom: 6px;\n}\n\n.baseFareFormLabelText {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 600;\n    color: var(--primary-foreground);\n    text-align: start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"baseFareFormText": `BaseFareForm-baseFareFormText-ITy41`,
	"baseFareFormLabelTextContainer": `BaseFareForm-baseFareFormLabelTextContainer-sVu9E`,
	"baseFareFormLabelText": `BaseFareForm-baseFareFormLabelText-MT2A9`
};
module.exports = ___CSS_LOADER_EXPORT___;
